import { render, staticRenderFns } from "./popup-block-options.vue?vue&type=template&id=2957e740&"
import script from "./popup-block-options.vue?vue&type=script&lang=js&"
export * from "./popup-block-options.vue?vue&type=script&lang=js&"
import style0 from "./popup-block-options.vue?vue&type=style&index=0&id=2957e740&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports